import format from 'date-fns/format'

export default function dateFormat(value: string | number | Date, withTime: boolean = true) {
  const d = new Date(value);

  return format(d, `dd.MM.yyyy${withTime ? ' HH:ii:ss' : ''}`)
}